import React, { useState, useEffect, useCallback } from 'react';
import { CableProvider } from './cables/CableContext';
import AuthStore from 'stores/AuthStore';
import {
  ProjectCable,
  CodeCable,
  ExcerptCable,
  TranscriptCable,
  MemoCable
} from './cables';

function CableLayer(props) {
  const [cableURL, setCableURL] = useState(AuthStore.getCableURL());

  useEffect(() => {
    const onChange = () => {
      const currentURL = AuthStore.getCableURL();
      if (currentURL && !cableURL) setCableURL(currentURL);
    };
    AuthStore.addChangeListener(onChange);
    return () => AuthStore.removeChangeListener(onChange);
  }, [cableURL]);

  const onDisconnected = useCallback(() => {
    console.log('disconnected cable');
    if (CABLE_DISCONNECT_FLAG) alert('disconnected from live updates');
  }, []);

  const onConnected = useCallback(() => {
    console.log('cable connected');
  }, []);

  const onRejected = useCallback(() => {
    console.log('cable rejected');
  }, []);

  return (
    <div>
      {cableURL && (
        <CableProvider url={cableURL}>
          {props.projectID && (
            <div>
              <ProjectCable 
                projectId={props.projectID}
                onDisconnected={onDisconnected}
                onConnected={onConnected}
                onRejected={onRejected}
              />
              <CodeCable projectId={props.projectID} />
              <ExcerptCable projectId={props.projectID} />
              <TranscriptCable projectId={props.projectID} />
              <MemoCable projectId={props.projectID} />
            </div>
          )}
        </CableProvider>
      )}
    </div>
  );
}

export default CableLayer;